import React from "react"
import {NavLink} from "react-router-dom";

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

 render() {
    return (
      <footer className="footer">
        <div className="container-fluid">
            <div className="level level-right is-mobile">
                <div>
                    <div className="">
                        <NavLink to="/instructions">
                            <span className="submenu-item-label">Instructions </span>
                        </NavLink>
                    </div>
                </div>
                <div>

                    <div className=""><p> | </p></div>
                </div>
                <div>
                    <div className="">
                        <NavLink to="/terms">
                            <span className="submenu-item-label">Terms of use </span>
                        </NavLink>
                    </div>
                </div>
                <div>
                    <div className=""><p> | </p></div>
                </div>
                <div>
                    <div className="">
                        <NavLink to="/privacy">
                            <span className="submenu-item-label">Privacy policy </span>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
      </footer>
    )
 }
}


export default Footer
